/** 识别原件保留策略 */
export type RecognitionOriginalPolicy = {
  retentionDays: number;
  allowedDays?: number[];
  defaultDays?: number;
};

/** 任务内识别原件摘要 */
export type RecognitionOriginalItem = {
  id: string;
  originalName: string;
  kind: string;
  status: string;
  createdAt: string;
  remainingDays: number;
  expiresAt: string;
};

/**
 * 生成上传区提示文案
 * @param policy 保留策略
 */
export function recognitionOriginalUploadHint(policy: RecognitionOriginalPolicy): string {
  return `支持 PDF / JPG / PNG · 原件保留 ${policy.retentionDays} 天，到期自动清除`;
}

/**
 * 生成发票上传弹窗提示文案
 * @param policy 保留策略
 */
export function recognitionOriginalUploadModalHint(policy: RecognitionOriginalPolicy): string {
  return `支持 PDF / JPG / PNG / XLSX / XLS · 原件保留 ${policy.retentionDays} 天，到期自动清除`;
}

/**
 * 生成任务详情保留天数提示
 * @param policy 保留策略
 * @param originals 当前任务原件列表
 */
export function recognitionOriginalRetentionNote(
  policy: RecognitionOriginalPolicy,
  originals: RecognitionOriginalItem[],
): string {
  if (!originals.length) {
    return `识别原件上传后保留 ${policy.retentionDays} 天，到期自动清除；删除任务时关联原件会立即清理。`;
  }
  const minRemaining = Math.min(...originals.map(item => item.remainingDays));
  return `当前任务共有 ${originals.length} 份识别原件，最早还剩 ${minRemaining} 天自动清除（系统策略 ${policy.retentionDays} 天）。`;
}

/**
 * 生成任务列表中的保留提示
 * @param policy 保留策略
 * @param originals 当前任务原件列表
 */
export function recognitionOriginalTaskRowNote(
  policy: RecognitionOriginalPolicy,
  originals: RecognitionOriginalItem[],
): string {
  if (!originals.length) return `原件保留 ${policy.retentionDays} 天`;
  const minRemaining = Math.min(...originals.map(item => item.remainingDays));
  return `原件还剩 ${minRemaining} 天`;
}
